import { CLIENT_TYPE_HEADER } from './ClientTypeHeader'

const generalHeader = (token) => ({
  accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Client-Type': CLIENT_TYPE_HEADER,
  ...(token && { Authorization: `Bearer ${token}` }),
})

export default generalHeader
